module App.Interfaces {
    export interface ICustomState extends angular.ui.IState {
        title: string;
        headerTitle: string;
        name: string;
        order?: number;
        operations: string[];
        configuratorStepName: string[];
        showInMenu: boolean;
    }
}